/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Automation_Trigger_Title7Inputs */

const en_svc_automation_trigger_title7 = /** @type {(inputs: Svc_Automation_Trigger_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event & schedule triggers`)
};

const ar_svc_automation_trigger_title7 = /** @type {(inputs: Svc_Automation_Trigger_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محفزات الأحداث والجدولة`)
};

const bn_svc_automation_trigger_title7 = /** @type {(inputs: Svc_Automation_Trigger_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ইভেন্ট ও শিডিউল ট্রিগার`)
};

const de_svc_automation_trigger_title7 = /** @type {(inputs: Svc_Automation_Trigger_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis- und Zeitplanauslöser`)
};

const es_svc_automation_trigger_title7 = /** @type {(inputs: Svc_Automation_Trigger_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activadores de eventos y horarios`)
};

const fr_svc_automation_trigger_title7 = /** @type {(inputs: Svc_Automation_Trigger_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déclencheurs d'événements et de planification`)
};

const pt_svc_automation_trigger_title7 = /** @type {(inputs: Svc_Automation_Trigger_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gatilhos de evento e programação`)
};

const zh_svc_automation_trigger_title7 = /** @type {(inputs: Svc_Automation_Trigger_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件和时间表触发器`)
};

const tr_svc_automation_trigger_title7 = /** @type {(inputs: Svc_Automation_Trigger_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinlik ve program tetikleyicileri`)
};

const ru_svc_automation_trigger_title7 = /** @type {(inputs: Svc_Automation_Trigger_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Триггеры событий и расписаний`)
};

const pl_svc_automation_trigger_title7 = /** @type {(inputs: Svc_Automation_Trigger_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyzwalacze zdarzeń i harmonogramu`)
};

/**
* | output |
* | --- |
* | "Event & schedule triggers" |
*
* @param {Svc_Automation_Trigger_Title7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_automation_trigger_title7 = /** @type {((inputs?: Svc_Automation_Trigger_Title7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Automation_Trigger_Title7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_automation_trigger_title7(inputs)
	if (locale === "bn") return bn_svc_automation_trigger_title7(inputs)
	if (locale === "de") return de_svc_automation_trigger_title7(inputs)
	if (locale === "es") return es_svc_automation_trigger_title7(inputs)
	if (locale === "fr") return fr_svc_automation_trigger_title7(inputs)
	if (locale === "pt") return pt_svc_automation_trigger_title7(inputs)
	if (locale === "zh") return zh_svc_automation_trigger_title7(inputs)
	if (locale === "tr") return tr_svc_automation_trigger_title7(inputs)
	if (locale === "ru") return ru_svc_automation_trigger_title7(inputs)
	if (locale === "pl") return pl_svc_automation_trigger_title7(inputs)
	return en_svc_automation_trigger_title7(inputs)
});
export { svc_automation_trigger_title7 as "svc_automation_TRIGGER_title" }